export default (eventId) => `/bet-builder-launcher/${eventId}`;
